import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { ShieldCheckIcon, LockIcon, CheckIcon } from 'lucide-react';
export function PricingSection() {
  return <section id="comprar" className="py-24 px-4 bg-[#111827] relative overflow-hidden" data-id="element-287">
      {/* Glow behind pricing card */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#c9a84c]/10 rounded-full blur-[120px] pointer-events-none" data-id="element-288" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-289">
        <FadeIn data-id="element-290">
          <div className="text-center mb-10" data-id="element-291">
            <h2 className="text-3xl md:text-4xl font-bold text-[#f5f5f5] mb-6" data-id="element-292">
              No vas apagar $97 que costará este programa el mes que viene.
            </h2>
            <p className="text-xl text-[#9ca3af]" data-id="element-293">
              Porque sé que el hombre latino necesita soluciones reales y
              accesibles, hoy puedes descargarlo por:
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-294">
          <div id="comprar" className="bg-[#0a0e1a] border-2 border-[#c9a84c] rounded-3xl p-8 md:p-12 text-center shadow-[0_0_50px_rgba(201,168,76,0.2)] max-w-2xl mx-auto" data-id="element-295">
            <div className="inline-block bg-[#dc2626] text-white font-bold px-4 py-1 rounded-full text-sm uppercase tracking-wider mb-6 animate-pulse" data-id="element-296">
              Oferta Especial Limitada
            </div>

            <div className="flex justify-center items-center gap-4 mb-4" data-id="element-297">
              <span className="text-3xl text-[#9ca3af] line-through decoration-[#dc2626] decoration-4" data-id="element-298">
                $97
              </span>
              <span className="text-6xl md:text-8xl font-extrabold text-[#c9a84c]" data-id="element-299">
                $9.99
              </span>
              <span className="text-xl text-[#9ca3af] font-bold mt-4" data-id="element-300">USD</span>
            </div>

            <p className="text-[#f5f5f5] font-medium mb-8 text-lg" data-id="element-301">
              (Pago único, acceso de por vida)
            </p>

            <Button href="https://www.tumomentovital.com/cart/47616565608640:1" onClick={() => {
            if ((window as any).fbq) {
              ;
              (window as any).fbq('track', 'AddToCart');
            }
          }} className="w-full text-xl py-6 mb-4 shadow-[0_0_30px_rgba(201,168,76,0.4)]" data-id="element-302">
              SÍ, QUIERO RECUPERAR MI ENERGÍA AHORA
            </Button>
            <div className="bg-[#111827]/80 border border-[#c9a84c]/20 rounded-xl p-5 mb-6 text-left" data-id="element-303">
              <p className="text-[#c9a84c] font-bold text-sm uppercase tracking-wide mb-4 text-center" data-id="element-304">
                Incluye 3 bonos de regalo — GRATIS
              </p>
              <div className="space-y-3" data-id="element-305">
                <div className="flex items-start gap-3" data-id="element-306">
                  <CheckIcon className="w-5 h-5 text-[#c9a84c] shrink-0 mt-0.5" data-id="element-307" />
                  <div data-id="element-308">
                    <span className="text-[#f5f5f5] font-medium text-sm" data-id="element-309">
                      Guía de Suplementos Alfa (Edición Latam)
                    </span>
                    <span className="text-[#9ca3af] text-xs ml-2 line-through" data-id="element-310">
                      $47
                    </span>
                    <span className="bg-green-500/20 text-green-400 font-bold px-1.5 py-0.5 rounded text-[10px] uppercase ml-1 border border-green-500/30" data-id="element-311">
                      GRATIS
                    </span>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-312">
                  <CheckIcon className="w-5 h-5 text-[#c9a84c] shrink-0 mt-0.5" data-id="element-313" />
                  <div data-id="element-314">
                    <span className="text-[#f5f5f5] font-medium text-sm" data-id="element-315">
                      Protocolo 'Libido de Acero'
                    </span>
                    <span className="text-[#9ca3af] text-xs ml-2 line-through" data-id="element-316">
                      $47
                    </span>
                    <span className="bg-green-500/20 text-green-400 font-bold px-1.5 py-0.5 rounded text-[10px] uppercase ml-1 border border-green-500/30" data-id="element-317">
                      GRATIS
                    </span>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-318">
                  <CheckIcon className="w-5 h-5 text-[#c9a84c] shrink-0 mt-0.5" data-id="element-319" />
                  <div data-id="element-320">
                    <span className="text-[#f5f5f5] font-medium text-sm" data-id="element-321">
                      Cheat-Sheet del Restaurante Latino
                    </span>
                    <span className="text-[#9ca3af] text-xs ml-2 line-through" data-id="element-322">
                      $47
                    </span>
                    <span className="bg-green-500/20 text-green-400 font-bold px-1.5 py-0.5 rounded text-[10px] uppercase ml-1 border border-green-500/30" data-id="element-323">
                      GRATIS
                    </span>
                  </div>
                </div>
              </div>
              <a href="#bono-1" className="mt-3 inline-block text-[#c9a84c]/70 hover:text-[#c9a84c] text-sm underline underline-offset-4 transition-colors text-center w-full" data-id="element-324">
                Más detalle de los bonos
              </a>
            </div>

            <div className="flex flex-wrap justify-center gap-6 text-sm text-[#9ca3af]" data-id="element-325">
              <div className="flex items-center gap-2" data-id="element-326">
                <ShieldCheckIcon className="w-5 h-5 text-[#c9a84c]" data-id="element-327" />
                <span data-id="element-328">Garantía de 7 Días</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-329">
                <LockIcon className="w-5 h-5 text-[#c9a84c]" data-id="element-330" />
                <span data-id="element-331">Pago 100% Seguro</span>
              </div>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-332">
          <div className="mt-12 text-center max-w-2xl mx-auto" data-id="element-333">
            <p className="text-[#9ca3af] italic" data-id="element-334">
              <strong className="text-[#f5f5f5]" data-id="element-335">¿Por qué tan barato?</strong>{' '}
              Porque prefiero tener 10,000 hombres recuperando su vida y
              recomendando este método, que a unos pocos pagando precios
              excesivos. Pero este precio solo es válido para los{' '}
              <strong className="text-[#dc2626]" data-id="element-336">
                siguientes 50 compradores
              </strong>
              .
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}